import Link from 'next/link';
import React from 'react';
import { IJobDetail } from 'types/jobs';
import { getJobDisplayTitle } from 'utils/jobCardHelper';
import { generateJobDetailsURL, generateLocationInfo } from 'utils/jobListingHelper';
import { useAnalytics } from 'utils/useAnalytics';

import { List, ListItem, ListItemText, Typography } from '@material-ui/core';
import ApartmentOutlinedIcon from '@material-ui/icons/ApartmentOutlined';
import RoomOutlinedIcon from '@material-ui/icons/RoomOutlined';

import styles from './SimilarJobs.module.scss';

interface SimilarJobsProps {
  jobs: IJobDetail[];
  referringJobNumber: string; // used for tracking so that we know which job drove traffic to another job
}

const SimilarJobs = ({ jobs, referringJobNumber }: SimilarJobsProps) => {
  const track = useAnalytics();
  return (
    <div className={styles.container}>
      {!!jobs.length && (
        <>
          <Typography variant="subtitle1" component="h4" className={styles.title}>
            Similar Jobs
          </Typography>
          <List dense={false}>
            {jobs.map(job => {
              const subspcialityOrSpeciality = job.subspeciality
                ? job.subspeciality
                : job.speciality;
              const jobUrl = generateJobDetailsURL(
                job.jobNumber,
                job.grade,
                subspcialityOrSpeciality,
              );
              const locationInfo = generateLocationInfo(job.locationDisplay, job.country, job.city);
              return (
                <ListItem key={job.id}>
                  <ListItemText
                    primary={
                      <Link
                        prefetch={false}
                        href={{
                          pathname: jobUrl,
                        }}
                        as={jobUrl}
                        onClick={() =>
                          track('Job Details', {
                            jobNumber: job.jobNumber,
                            'Details Origin': 'Similar Jobs',
                            'Details Action': 'Title Link',
                            referringJobNumber,
                          })
                        }
                      >
                        <Typography variant="subtitle1" component="h5" data-testid="title">
                          {getJobDisplayTitle(job)}
                        </Typography>
                      </Link>
                    }
                    secondary={
                      <>
                        {/*
                          TODO: This code needs to be changed - it's currently nesting p tags inside other p tags
                          which is not syntactically correct HTML.
                        */}
                        <Typography variant="body1" component="p">
                          <RoomOutlinedIcon />
                          <span data-testid="similar-job-location">{locationInfo}</span>
                        </Typography>
                        <Typography variant="body1" component="p">
                          <ApartmentOutlinedIcon />
                          <span data-testid="work-type">{job.workType}</span>
                        </Typography>
                      </>
                    }
                  />
                </ListItem>
              );
            })}
          </List>
        </>
      )}
    </div>
  );
};

export default SimilarJobs;
